import React from 'react';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';

import { Field } from 'redux-form';
import {
  Months,
  numberOnly,
  alphabeticalAndSomeChar,
  inputField,
  renderSelectField,
} from '../utilsForm';
import styles from './koinworksForm.css';

const KoinworksBusinessForm = props => {
  const { businessLocationsState, businessStartsState } = props;

  return (
    <div className={`col-md-12 col-lg-12`}>
      <div className="col-md-3">
        <label>Business Information</label>
      </div>
      <div className="col-md-9">
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Business Name<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="business_name"
              maxLength="255"
              placeholder="Your business/company name"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            When Does <br /> Your Business Start?<red>*</red>
          </label>
          <div className="col-sm-4 col-lg-2">
            <Field
              name="business_start_month"
              className={`form-control ${styles['bank-select']}`}
              id="marital_status"
              component={renderSelectField}
            >
              <option value="" key="">
                Month...
              </option>
              {Months.map(option => (
                <option value={option.value} key={option.value}>
                  {option.name}
                </option>
              ))}
            </Field>
          </div>
          <div className="col-sm-4 col-lg-2">
            <Field
              name="business_start_year"
              className={`form-control ${styles['bank-select']}`}
              id="marital_status"
              component={renderSelectField}
            >
              <option value="" key="">
                Year...
              </option>
              {businessStartsState.map(option => (
                <option value={option.code} key={option.name}>
                  {option.name}
                </option>
              ))}
            </Field>
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Business Phone Number<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={PhoneNumberField}
              name="business_contact"
              type="tel"
              placeholder=""
              errorRegister
              showTextError
              customClassName={styles['account-name']}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Business Email<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="email"
              maxLength="255"
              placeholder="Email"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
            />
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="business_description"
            className="col-sm-4 col-form-label"
          >
            Business Description<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="business_description"
              maxLength="255"
              placeholder="business description"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
            />
          </div>
        </div>
        {/* <div className='form-group row'>
          <label htmlFor='inputEmail3' className='col-sm-4 col-form-label'>Business Type<red>*</red></label>
          <div className='col-sm-offset-4 col-sm-8'>
            <Field
              name='business_type'
              className={`form-control ${styles['bank-select']}`}
              id='business_type _id'
              component={renderSelectField}>
              <option key={0} value=''>Select Business Type...</option>
              { businessTypeState && businessTypeState.map(option => <option value={option.name} key={option.id}>{option.name}</option>) }
            </Field>
          </div>
        </div> */}
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Business Address<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="business_address"
              maxLength="255"
              placeholder="Your Business Address"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphabeticalAndSomeChar()}
            />
          </div>
          <div className="col-sm-offset-4 col-sm-8">
            <Field
              component={inputField}
              name="business_city"
              maxLength="255"
              placeholder="City"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphabeticalAndSomeChar()}
            />
          </div>
          <div className="col-sm-offset-4 col-sm-8">
            <Field
              name="business_province"
              className={`form-control ${styles['bank-select']}`}
              id="business_location _id"
              component={renderSelectField}
            >
              <option key={0} value="">
                Select Province...
              </option>
              {businessLocationsState.map(option => (
                <option value={option.name} key={option.id}>
                  {option.name}
                </option>
              ))}
            </Field>
          </div>
          <div className="col-sm-offset-4 col-sm-8">
            <Field
              component={inputField}
              name="business_zipcode"
              maxLength="5"
              placeholder="Zip"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={numberOnly()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KoinworksBusinessForm;
